import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class JsonExportService {
    jsonanzahl: number;
    elabel: string;


    constructor(
        http: HttpClient,
    
    ) {}


  downloadFile(data, filename='data') {
    const csvData = data;
    console.log(csvData);
    const blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    const dwldLink = document.createElement('a');
    const url = URL.createObjectURL(blob);
    const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
    if (isSafariBrowser) {
        dwldLink.setAttribute('target', '_blank');
    }
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.csv');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);

}

// ConvertToCSV(objArray, headerList) {
//      const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
//      let str = '';
//      let row = 'S.No,';

//      // tslint:disable-next-line:forin
//      for (const index in headerList) {
//          row += headerList[index] + ',';
//      }
//      row = row.slice(0, -1);
//      str += row + '\r\n';
//      for (let i = 0; i < array.length; i++) {
//          let line = (i + 1) + '';
//          // tslint:disable-next-line:forin
//          for (const index in headerList) {
//             const head = headerList[index];

//              line += ',' + array[i][head];
//          }
//          str += line + '\r\n';
//      }
//      return str;
//  }




json2output(json, mapping, language) {
    console.log(json);
    console.log(mapping);
    console.log(language);
    // welcher Modus wird angewendet, momentan gibt es nur fud-json. Bei mehren Modis zu überlegen, ob in übergeordnetet Funktion auszulagern, die dann bei Modus fud-json ein Funktion (if-part) aufruft.
    // mapping.elements Sortierung sollte Aufgabe des Eingabe-/Erstellungsformulars sein => mapping.elemens ist hier schon in richtiger Reihenfolge.
    // language gibt an, welche Sprache für elabels und strings verwendet wird.
    // mapping = JSON.parse(mapping.value);
    
    let ausgabe;
    let error;

    if (mapping.inputformat === "fud-json") {
        // json = JSON.parse(json.value);
        let modus;
        // handelt es sich bei json um eine Liste oder ein einzelnes JSON-Dokument (Liste bezieht sich auf Trefferliste, von daher wird Element .hits geprüft, ob vorhanden ist).
        if (typeof json.hits === "undefined") {
            this.jsonanzahl = 1;
            modus = "single";
        } else {
            json = json.hits.hits;
            this.jsonanzahl = json.length;
            if (this.jsonanzahl > 1000) {
                let info = "Anzahl der Dokumente (" + this.jsonanzahl + ") > 1000. Es werden aber nur die ersten 1000 Dokumente auf einmal exportiert!"
                console.log(info);
                this.jsonanzahl = 1000;
            }
            modus = "list";
        }

        // Auslesen outputmodus: in welches Format soll umgewandelt werden?
        let outputmodus = mapping.outputmodus;
        if (!outputmodus) {
            error =
                "Outputmodus '" +
                mapping.outputmodus +
                "' ist nicht definiert => Abbruch!";
            return error;
        }

        // Einlesen der Trenner von Elementen und Elementlisten.
        let etrenner = mapping.elementtrenner.trenner;
        let etrenneroption = mapping.elementtrenner.option;
        let epre = mapping.elementpre;
        let epost = mapping.elementpost;
        let elistpre = mapping.elistpre;
        let elistpost = mapping.elistpost;

        // Wenn es pretext für ausgabe gibt, wird dieser Text hier in ausgabe an den Anfang gesetzt.
        if (mapping.pretext) {
            ausgabe = mapping.pretext;
        }

        // für die Modi 'csv' und 'htmltabelle' wird einen headerzeile generiert.
        // TODO: für 'detailansicht' könnte man auch heading-Zeile anhand von Kriterien definieren, z.B. anhand etemplate: heading.
        if (outputmodus == "csv" || outputmodus == "tsv" || outputmodus === "htmltabelle") {
            let zbegin;
            if (epre) zbegin = epre.replace("<td>", "<th>");
            let zend;
            if (epost) zend = epost.replace("</td>", "</th>");
            ausgabe = this.myconcat([ausgabe, elistpre]);
            for (let i = 0; i < mapping.elements.length; i++) {
                let labelarray = mapping.elements[i].elabel;
                let labelinlang = "no_label_information";
                for (let li = 0; li < labelarray.length; li++) {
                    // wenn keine Sprache für Label angegeben ist, wird das als default-Wert verwendet, der vom Sprachlabel überschrieben werden kann.
                    let labellang = labelarray[li].lang;
                    if (!labellang) {
                        labelinlang = labelarray[li].labelstring;
                    } else if (labellang == language) {
                        labelinlang = labelarray[li].labelstring;
                        break;
                    }
                }
                ausgabe = this.myconcat([
                    ausgabe,
                    zbegin,
                    labelinlang,
                    zend,
                    etrenner,
                ]);
            }
            ausgabe = this.myconcat([ausgabe, elistpost]);
        }

        for (let n = 0; n < this.jsonanzahl; n++) {
            // Schleife über alle Dokumente im json
            let jsonarray;
            if (modus === "single") {
                jsonarray = json._source;
            } else if (modus === "list") {
                jsonarray = json[n]._source;
            } else {
                console.log('Falscher Modus:');
                ausgabe = "Falscher Modus: " + modus;
                return ausgabe;
            }
            console.log(json._source);

            let ausgabeblock = "";
            for (let mi = 0; mi < mapping.elements.length; mi++) {
                // Schleife über alle Ausgabeelemente in mapping
                let econtent = mapping.elements[mi].econtent; // array of element(s)
                if (outputmodus == "webpublish") {
                    // default: Jede Zeile wird in ein eigenes div class='zeile' geschrieben!
                    let elabel = mapping.elements[mi].elabel;
                    let csslabel = mapping.elements[mi].elabelclass;
                    if (typeof csslabel === "undefined") {
                        csslabel = "label";
                    }
                    elabel = this.myconcat([
                        '<div class="zeile"><div class="',
                        csslabel,
                        '">',
                        elabel,
                        "</div>",
                    ]);
                    epost = this.myconcat([epost, "</div>"]);
                } else {
                    // bei den beiden anderen Modi (csv und htmltabelle) stehen labels schon in Überschriftenzeile.
                    // ToDo: verallgemeinern und von Modi unabhängig programmieren (vertikal vs. horizontal).
                    this.elabel = "";
                }
                let elementinhalt = ""; // nächste for-Schleife gibt den Inhalt eines Elements zurück in var elementinhalt zurück.
                let varcontent = ""; //varcontent ist Hilfvariabel für Aufbau des elementinhalts.
                for (let mii = 0; mii < econtent.length; mii++) {
                    // Schleife über econtent = alle Elemente des Feldinhalts.
                    let vartyp = econtent[mii].etype;
                    let varinhalt = econtent[mii].epart;
                    let defaultwert = econtent[mii].default;
                    if (vartyp == "string") {
                        // epart ist eine Zeichenfolge, die direkt so als Feldinhalt übernommen werden kann.
                        let sprache = econtent[mii].elang;
                        // String wird nur geschrieben, wenn keine Sprache hinterlegt ist => default-Wert für alle Sprachen oder der String für die gewählte Sprache verwendet werden soll.
                        if ((!sprache) || (sprache == language)) {
                            elementinhalt = this.myconcat([elementinhalt, varinhalt]);
                        }
                    } else if (vartyp == "json") {
                        // Die Angabe in epart ist ein FuD-Json-Feld, deren Wert direkt aus json übernommen werden kann.
                        // Funktion splitebenen liest hierarchische Wert korrekt aus, so kann hier auch nested Objekte, z.B. docTyp.name oder später lmAdd.gnd, wenn Model das  ausgelesen werden können.
                        //let varcontent = splitebenen(jsonarray, varinhalt);
                        console.log(jsonarray);
                        console.log(varinhalt);
                        
                        varcontent = this.splitebenen(jsonarray, varinhalt);
                        if (!varcontent) {
                            varcontent = defaultwert;
                        }
                        elementinhalt = this.myconcat([elementinhalt, varcontent]);
                    } else if (vartyp == "block") {
                        // epart ist entweder lre-Feld oder wiederholbarer Block.
                        let block = jsonarray[varinhalt];
                        if (typeof block == "undefined") {
                            //wenn es keine json mit dem Attributname varinhalt gibt, wird der Rest nicht gemacht, es wird einen leere Zeichenfolge geschrieben.
                            elementinhalt = this.myconcat([elementinhalt, ""]);
                        } else {
                            let subdef = econtent[mii].subcontent;
                            let blocktrenner = econtent[mii].blocktrenner;
                            let blocknr = econtent[mii].espez;
                            if (typeof blocknr == "undefined") {
                                // bei mehreren wiederholbaren Felder auf Registerkarte muss subid überprüft werden. Diese sollten dann in Mapping als espez eingetragen werden!
                                blocknr = 0;
                            }
                            let blockinhalt;
                            for (let subn = 0; subn < block.length; subn++) {
                                let blockzeile;
                                let subid = block[subn].subID;
                                if (
                                    (typeof subid === "undefined" && blocknr == 0) ||
                                    subid == blocknr
                                ) {
                                    if (
                                        typeof blockinhalt !== "undefined" &&
                                        !blockinhalt.endsWith(blocktrenner)
                                    ) {
                                        // blocktrenner wird erst ab dem 2. Element eingefügt, wenn blockzeile nicht leer ist!
                                        blockinhalt = this.myconcat([blockinhalt, blocktrenner]);
                                    }
                                    for (let miii = 0; miii < subdef.length; miii++) {
                                        let blocketype = subdef[miii].etype;
                                        let blockepart = subdef[miii].epart;
                                        let blockdefault = subdef[miii].default;
                                        // Abprüfung auf blocknr nicht nötig, da fieldname in FuD pro Dokumenttyp eindeutig!
                                        if (blocketype == "string") {
                                            // epart ist eine Zeichenfolge, die direkt so als Feldinhalt übernommen werden kann.
                                            let sprache = subdef[miii].elang;
                                            // String wird nur geschrieben, wenn keine Sprache hinterlegt ist => default-Wert für alle Sprachen oder der String für die gewählte Sprache verwendet werden soll.
                                            if ((!sprache) || (sprache == language)) {
                                                blockzeile = this.myconcat([blockzeile, blockepart]);
                                            }
                                        } else if (blocketype == "json") {
                                            // Die Angabe in epart ist ein FuD-Json-Feld, deren Wert direkt aus json übernommen werden kann.
                                            let hcontent = this.splitebenen(block[subn], blockepart);
                                            if (!hcontent) {
                                                hcontent = blockdefault;
                                            }
                                            blockzeile = this.myconcat([blockzeile, hcontent]);
                                        } else if (blocketype == "block" || blocketype == "lmAdd") {
                                            // lre1/2-Feld in wiederholbaren Block, sonst gibt es das nicht, da FuD nicht Block in Block darstellen kann.
                                            // ToDo: hier kann es dann aber nur JSON und String.
                                            //} else if (blocktype == 'lmAdd') {
                                            // epart ist ein zusätzliches Lemmafeld eines lre-Feldes (lmAdd).
                                        } else if (blocketype == "lmAdd_array") {
                                            // Option für die alte Version im Elasticmodel, dass lmAdd-Felder in ein Objekt mit Feldern "tID": "2065", "field": "gnd", "val": "http://d-nb.info/gnd/121734307" geschrieben werden.
                                            // hier läuft man array solange durch bis field == blockepart ist und liest dann val aus!
                                            // in neueren Elasticmodels sollte es so sein, dass es gnd ein einfaches child-Element ist => etype = json und epart = lmAdd.gnd
                                            let lmAdd_array = block[subn].LmAdd;
                                            let hcontent = blockdefault;
                                            for (let lmi = 0; lmi < lmAdd_array.length; lmi++) {
                                                let lmfield = lmAdd_array[lmi].field;
                                                if (lmfield == blockepart) {
                                                    // wenn Wert gefunden wird, wird hcontent überschrieben. Ansonsten wird default-Wert geschrieben, sollte dieser vorhanden sein.
                                                    hcontent = lmAdd_array[lmi].val;
                                                    break;
                                                }
                                            }
                                            blockzeile = this.myconcat([blockzeile, hcontent]);
                                        } else {
                                            // Subtyp ist bisher noch nicht definiert worden.
                                            // Typ anhang kann es im Block nicht geben, da m-/k-Felder nicht in wiederholbaren Blöcken gibt (-> kf-/mf-Felder).
                                            error = this.myconcat([
                                                "Dieser subcontent.etype ",
                                                vartyp,
                                                "mit Inhalt ",
                                                varinhalt,
                                                " ist noch nicht definiert!",
                                            ]);
                                            console.log(error);
                                        }
                                    }
                                } else {
                                    // entweder lre-Feld, dann ist blocknr = 0 oder Fehler!
                                    error =
                                        "Block (" +
                                        block +
                                        ") hat keine subId und ist kein lre-Feld (" +
                                        varinhalt +
                                        ") => kann nicht gelesen werden.";
                                    console.log(error);
                                    break;
                                }
                                //Inhalt der letzten Blockzeile wird blockinhalt hinzugefügt. Für alle anderen wird es nach Durchlauf der Schleife immer am Anfang gemacht, da der blocktrenner gesetzt werden muss.
                                blockinhalt = this.myconcat([blockinhalt, blockzeile]);
                            }
                            elementinhalt = this.myconcat([elementinhalt, blockinhalt]);
                        }
                    } else if (vartyp == "anhang") {
                        // epart ist k- oder m-Feld.
                        // in espez steht maximale Anzahl der Felder.
                        // econtent kann nur EIN Element enthalten => alle anderen Elemente werden nicht berücksichtigt.
                        let subdef = econtent[mii].subcontent;
                        let blocktrenner = econtent[mii].blocktrenner;
                        let feldtyp = econtent[mii].fudfeldtyp;
                        let digmax = econtent[mii].espez;
                        let anhanginhalt;
                        for (let dignr = 0; dignr < digmax; dignr++) {
                            let anhangzelle;
                            let schreiben = "nein";
                            // nur 'string' und 'anhang' dürfen vorkommen. Andere Typen machen momentan keinen Sinn (?).
                            for (let miii = 0; miii < subdef.length; miii++) {
                                let subtype = subdef[miii].etype;
                                let subpart = subdef[miii].epart;
                                // das komplette Anhangelement wird nur geschrieben, wenn ein JSON-Element von Typ anhang Inhalt hat. Wenn das nicht der Fall ist, sollten die STringwerte eben auch nicht
                                if (subtype == "anhang") {
                                    let hilfvar = subpart + dignr;
                                    if (jsonarray[hilfvar]) {
                                        anhangzelle = this.myconcat([anhangzelle, jsonarray[hilfvar]]);
                                        schreiben = "ja";
                                    }
                                } else if (subtype == "string") {
                                    let sprache = subdef[miii].elang;
                                    // String wird nur geschrieben, wenn keine Sprache hinterlegt ist => default-Wert für alle Sprachen oder der String für die gewählte Sprache verwendet werden soll.
                                    if ((!sprache) || (sprache == language)) {
                                        anhangzelle = this.myconcat([anhangzelle, subpart]);
                                    }
                                } else {
                                    error =
                                        "Dieser subtype " +
                                        subtype +
                                        " sollte bei Anhang nicht vorkommen bzw. ist nicht definiert!";
                                    console.log(error);
                                }
                            }
                            if (schreiben == "ja") {
                                if (anhanginhalt) {
                                    anhanginhalt = this.myconcat([
                                        anhanginhalt,
                                        blocktrenner,
                                        anhangzelle,
                                    ]);
                                } else {
                                    // 1. Mal wird Inhalt geschrieben => bekommt keinen Blocktrenner!
                                    anhanginhalt = anhangzelle;
                                }
                            }
                        }
                        elementinhalt = this.myconcat([elementinhalt, anhanginhalt]);
                    } else if (vartyp == "child") {
                        // epart = Kindelement eines Blocks oder eines lre-Feldes, z.B. wenn lmAdd als Array aufgebaut ist.
                    } else {
                        // Typ ist bisher noch nicht definiert worden.
                        // lmAdd kann nur auf block-Ebene als etype vorkommen.
                        error = this.myconcat([
                            "Dieser etype ",
                            vartyp,
                            "mit Inhalt ",
                            varinhalt,
                            " ist noch nicht definiert!",
                        ]);
                        console.log(error);
                    }
                }
                //csv: Zeilenausgabe!
                if (elementinhalt) {
                    // Anführungszeichen werden im csv doppelt escapt. Dies ist vor allem wichtig, wenn \n in String vorhanden ist, das durchaus sein kann.
                    elementinhalt = elementinhalt.replace(/["]/g, '""');
                }
                if (etrenneroption == "nolast" && mi == mapping.elements.length) {
                    // wenn eine Zeile geschrieben wird, gibt es Formate, die keinen Abschlusstrennung brauchen, z.B. csv. Ein \t am Schluss würde weitere leere Spalte erzeugen => option nolast!
                    // ausgabeblock ist bei csv = Zeile! elementinhalt ist Zelleninhalt => Einsatz 'nolast' erst nach letztem Element der Zeile!
                    ausgabeblock = this.myconcat([
                        ausgabeblock,
                        this.elabel,
                        epre, '"',
                        elementinhalt, '"',
                        epost,
                    ]);
                } else {
                    ausgabeblock = this.myconcat([
                        ausgabeblock,
                        this.elabel,
                        epre, '"',
                        elementinhalt, '"',
                        epost,
                        etrenner,
                    ]);
                }
            }
            ausgabe = this.myconcat([ausgabe, elistpre, ausgabeblock, elistpost]);
        }
        this.downloadFile(ausgabe);
        // return ausgabe;
    } else {
        error = "Modus '" + mapping.inputformat + "' ist unbekannt => Abbruch!";
        console.log(error);
        return error;
    }
}

splitebenen(a1, var1) {
    let splitteile = var1.split(".");
    for (let i = 0; i < splitteile.length; i++) {
        let splitteilx = splitteile[i];
        a1 = a1[splitteilx];
    }
    return a1;
}

myconcat(eingabearray) {
    // um undefinierte Werte hier nicht mit reinzuschreiben, wird array.prototyp.join verwendet. Damit nicht Komma als Trennzeichen verwendet wird (default) => '' als Parameter.
    return eingabearray.join("");
}

lmaddcontent(lrecontent, lmaddfname) {
    //lrecontent: Objekt des jeweiligen lre-Elementes
    //lmaddinput: Festlegung: lmAdd~~field, z.B. lmAdd~~gnd
    for (let lmaddnr in lrecontent) {
        //LmAdd-Objekte sind momentan DHIParis wie folgt aufgebaut: tid, field, val
        //im Webinar schon: Feldname: Feldinhalt, da wird diese Funktion nicht mehr gebraucht, da es mit splitebenen funktionieren müsste.
        if (lmaddfname == lrecontent[lmaddnr].field) {
            return lrecontent[lmaddnr].val;
        }
    }
}


}
